export default __webpack_public_path__ + "static/media/AppDevelopment.1fb9d73b.png";